import { Checkbox, Responsive, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';
import { IconFileDocument16, IconMediaPhoto16 } from '@cian/ui-kit-design-tokens/icons';
import classnames from 'classnames';
import * as React from 'react';

import * as styles from './ChatListItem.css';
import { ChatListItemSwipeButton, EChatListItemSwipeButtonType } from './ChatListItemSwipeButton';
// @ts-expect-error TODO: исправить импорт картинок
import advertImg from './assets/advert.svg';
import { TFormattedCompanionData } from '../../hooks';
import { EMessageFileTypes } from '../../types/messageFiles';
import { TOutcomingStatus } from '../../types/messages';
import { ERoute, TRoute } from '../../types/route';
import { useLeftSwipeVisible } from '../../utils/useLeftSwipeVisible';
import { MessageStatusIcon } from '../MessageStatusIcon';

type TChatListItemProps = {
  chatId: string;
  checkboxChecked: boolean;
  checkboxShown: boolean;
  companion: TFormattedCompanionData;
  isActive: boolean;
  fileLastMessage?: { type: EMessageFileTypes; name: string };
  isOfferLastMessage?: boolean;
  message: string;
  isMultilineMessage: boolean;
  onClick(): void;
  onSwipeButtonClick(action: EChatListItemSwipeButtonType): void;
  status?: TOutcomingStatus;
  unreadCount: number;
  date: string;
  previewNode: React.ReactNode;
  offerInfo?: string;
  currentRoute: TRoute;
  lastMessageName?: string;
  openedChatRef?: React.RefObject<HTMLDivElement>;
};

const CHAT_LIST_FILE_ICON = {
  [EMessageFileTypes.Image]: <IconMediaPhoto16 />,
  [EMessageFileTypes.ImageAsDocument]: <IconFileDocument16 />,
  [EMessageFileTypes.Document]: <IconFileDocument16 />,
};

export const ChatListItem: React.FC<TChatListItemProps> = ({
  chatId,
  checkboxChecked,
  checkboxShown,
  companion = {},
  isActive,
  fileLastMessage,
  message,
  isMultilineMessage,
  isOfferLastMessage,
  onClick,
  onSwipeButtonClick,
  status,
  unreadCount,
  date,
  previewNode,
  offerInfo,
  currentRoute,
  lastMessageName,
  openedChatRef,
}) => {
  const { companionName, accountTypeName, companionIdStr } = companion;
  const isLeftSwipeVisible = useLeftSwipeVisible();

  return (
    <div
      className={classnames(styles['item'], isActive && styles['item--active'])}
      onClick={onClick}
      data-chatid={chatId}
      ref={isActive ? openedChatRef : undefined}
    >
      {!checkboxShown && (
        <Responsive phone tablet>
          <div
            className={classnames(
              styles['left-swipe-button'],
              /* TODO: функционал непрочитанности пока не готов на сервере, а прочитать можно */
              unreadCount > 0 && isLeftSwipeVisible && styles['left-swipe-button--shown'],
            )}
          >
            <ChatListItemSwipeButton
              type={unreadCount > 0 ? EChatListItemSwipeButtonType.Read : EChatListItemSwipeButtonType.Unread}
              onClick={onSwipeButtonClick}
            />
          </div>
        </Responsive>
      )}

      <div className={styles['item-container']}>
        {checkboxShown && (
          <span className={styles['checkbox']}>
            <Checkbox onClick={e => e.preventDefault()} value={chatId} checked={checkboxChecked} />
          </span>
        )}
        {previewNode}
        <div className={styles['info']}>
          <div className={styles['common']}>
            <span className={styles['username']}>
              <UIHeading4 whiteSpace="nowrap">
                {companionName || (
                  <>
                    {accountTypeName}&nbsp;<UIText2 color="gray60_100">{`(${companionIdStr})`}</UIText2>
                  </>
                )}
              </UIHeading4>
            </span>
            <UIText2 color="gray60_100" whiteSpace="nowrap">
              {date}
            </UIText2>
            {status && <MessageStatusIcon status={status} />}
          </div>
          <div className={styles['details']}>
            <div className={styles['texts']}>
              {offerInfo && (
                <UIText1>
                  <div className={styles['offer-info']}>{offerInfo}</div>
                </UIText1>
              )}
              <UIText1 color="gray60_100">
                <span className={styles['message']}>
                  {lastMessageName && <span>{lastMessageName}</span>}
                  {fileLastMessage && (
                    <>
                      {fileLastMessage.type
                        ? CHAT_LIST_FILE_ICON[fileLastMessage.type]
                        : CHAT_LIST_FILE_ICON[EMessageFileTypes.Document]}
                      <span className={styles['text']}>
                        {fileLastMessage.type === EMessageFileTypes.Image ? 'Фото' : fileLastMessage.name}
                      </span>
                    </>
                  )}
                  {isOfferLastMessage && (
                    <>
                      <img src={advertImg} width={16} height={16} />
                      <span className={styles['text']}>Объявление</span>
                    </>
                  )}
                  {!fileLastMessage && !isOfferLastMessage && (
                    <span className={classnames(styles['text'], isMultilineMessage && styles['multiline'])}>
                      {message}
                    </span>
                  )}
                </span>
              </UIText1>
            </div>
            {unreadCount !== 0 && (
              <span data-testid="unreadCounter" className={styles['counter']}>
                {unreadCount}
              </span>
            )}
          </div>
        </div>
      </div>
      {!checkboxShown && (
        <Responsive phone tablet>
          {currentRoute === ERoute.Spam ? (
            <ChatListItemSwipeButton type={EChatListItemSwipeButtonType.Unblock} onClick={onSwipeButtonClick} />
          ) : (
            <>
              <ChatListItemSwipeButton type={EChatListItemSwipeButtonType.Delete} onClick={onSwipeButtonClick} />
              <ChatListItemSwipeButton
                type={
                  currentRoute === ERoute.Archive
                    ? EChatListItemSwipeButtonType.Return
                    : EChatListItemSwipeButtonType.Archive
                }
                onClick={onSwipeButtonClick}
              />
            </>
          )}
        </Responsive>
      )}
    </div>
  );
};
